import { cn } from "@/lib/utils";

interface CharacterCounterProps {
  count: number;
  max: number;
  className?: string;
}

/** "N / MAX characters" under a text box. Turns red once the limit is reached. */
export function CharacterCounter({ count, max, className }: CharacterCounterProps) {
  const isAtLimit = count >= max;
  return (
    <p
      className={cn("text-xs", isAtLimit ? "font-medium text-destructive" : "text-muted-foreground", className)}
      data-testid="character-counter"
      data-at-limit={isAtLimit}
    >
      {count.toLocaleString()} / {max.toLocaleString()} characters
    </p>
  );
}
